import { events } from '@estee/elc-service-bus';

import { EventRepository } from '~repositories/EventRepository';
import serviceNames from '~setup/AnalyticsService';
import { diContainer } from '~setup/diContainer';
import { Event } from '~entities/Event';

interface defaultPayload {
    nonInteraction: boolean;
}
export class CartOverlayClosed {
    private eventRepository: EventRepository;
    private nonInteraction: boolean;

    constructor(props: defaultPayload) {
        this.eventRepository = diContainer.get(serviceNames.eventRepository);
        this.nonInteraction = props.nonInteraction;
    }

    public execute = () => {
        const payload = {
            event_name: 'cart overlay',
            event_category: 'ecommerce',
            event_action: 'cart overlay',
            event_label: 'close',
            event_noninteraction: this.nonInteraction
        };

        const newEvent = new Event({
            id: this.eventRepository.generateId(),
            name: events.CART_OVERLAY_CLOSED,
            type: 'link',
            payload
        });

        this.eventRepository.addEventToQueue(newEvent);
    };
}
